export const homeObjOne = {
  id: "residential",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Residential",
  headline: "DC House 1",
  description:
    "The homes we design for our clients are more than places to live, they are places where families gather, memories are made, and intimate time is shared. Everyone has their own thoughts on what their ideal home looks like, and the passion of our luxury home architects is bringing these images to life.",
  buttonLabel: "VIEW GALLERY",
  imgStart: false,
  img: require("../../images/house1.svg"),
  alt: "House",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "commercial",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Commercial",
  headline: "DC House 2",
  description:
    "Your building or office space is a reflection of your business. It should speak to the high quality of services and products awaiting your customers when they walk through the door. Commercial design shouldn’t be synonymous with mediocrity. Just because we have designed bank branches and medical offices doesn’t mean we roll out the same blueprint on every commercial project or upfit we are invited to design. Our years of experience don’t dictate your project’s design, they only serve to enhance your vision.",
  buttonLabel: "VIEW GALLERY",
  imgStart: true,
  img: require("../../images/commercial.svg"),
  alt: "House2",
  dark: false,
  primary: false,
  darkText: true,
};
